// Module
var code = "\n<div class=\"schema-form-section {{form.htmlClass}}\">\n  <sf-decorator ng-repeat=\"item in form.items\" form=\"item\"></sf-decorator>\n</div>";
// Exports
export default code;